import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_img = _resolveComponent("q-img")!

  return (_openBlock(), _createBlock(_component_q_img, {
    src: _ctx.url,
    class: _normalizeClass(_ctx.classes),
    width: _ctx.imgSize,
    "spinner-color": "primary"
  }, null, 8, ["src", "class", "width"]))
}